export default {
    /**
     * @description 配置系统url
     */
    SYSTEM_URL:'https://data.mssdk.vip',
    BASE_URL:'https://data.mssdk.vip/ms_resource',
}